import React, { useState } from 'react';
import AnimatedLogo from './AnimatedLogo';

const WA_GREEN = '#25d366';
const DARK     = '#000000';
const SIDEBAR  = '#0c0c1a';
const BORDER   = 'rgba(255,255,255,0.08)';
const TEXT     = '#f8fafc';
const MUTED    = '#94a3b8';

// SVG sidebar icons
const IconDashboard  = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>;
const IconUsers      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconPhone      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.94a16 16 0 0 0 6.06 6.06l1.06-1.06a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>;
const IconQueue      = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
const IconAI         = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73A2 2 0 0 1 10 4a2 2 0 0 1 2-2z"/><circle cx="9" cy="14" r="1" fill="currentColor" strokeWidth="0"/><circle cx="15" cy="14" r="1" fill="currentColor" strokeWidth="0"/></svg>;
const IconWhatsApp   = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>;
const IconReports    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;
const IconSettings   = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;

const SIDEBAR_ITEMS = [
  { Icon: IconDashboard, label: 'Dashboard',    hidden: true },
  { Icon: IconUsers,     label: 'Users',        hidden: true },
  { Icon: IconPhone,     label: 'Extensions',   hidden: true },
  { Icon: IconQueue,     label: 'Queues',       hidden: true },
  { Icon: IconAI,        label: 'AI Assistant', hidden: true },
  { Icon: IconWhatsApp,  label: 'WhatsApp',     hidden: false, active: true },
  { Icon: IconReports,   label: 'Reports',      hidden: true },
  { Icon: IconSettings,  label: 'Settings',     hidden: true },
];

function FakeToggle({ on }: { on: boolean }) {
  return (
    <div style={{
      width: 44, height: 24, borderRadius: 12,
      background: on ? WA_GREEN : '#d1d5db',
      position: 'relative', flexShrink: 0, cursor: 'default',
    }}>
      <div style={{
        position: 'absolute', top: 3, left: on ? 23 : 3,
        width: 18, height: 18, borderRadius: '50%', background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      }} />
    </div>
  );
}

function FakeInput({ value, wide }: { value: string; wide?: boolean }) {
  return (
    <div style={{
      width: wide ? '100%' : undefined,
      padding: '9px 12px', borderRadius: 8,
      border: '1px solid #d1d5db', fontSize: 14, color: '#111827',
      background: '#f9fafb', fontFamily: 'monospace', userSelect: 'none',
      boxSizing: 'border-box',
    }}>{value}</div>
  );
}

function FakeButton({ label, color }: { label: string; color?: string }) {
  return (
    <div style={{
      display: 'inline-block',
      padding: '8px 16px', borderRadius: 8,
      background: color || WA_GREEN,
      color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'default',
    }}>{label}</div>
  );
}


const SynergyLogo = ({ width = 80 }: { width?: number }) => {
  const h = Math.round(width * 84 / 161);
  return (
    <svg viewBox="0 0 161 84" width={width} height={h} xmlns="http://www.w3.org/2000/svg" aria-label="CallEssential by Synergytalk">
      <style>{`
        @keyframes stBar0{0%,100%{transform:scaleY(0.28)}50%{transform:scaleY(0.62)}}
        @keyframes stBar1{0%,100%{transform:scaleY(0.42)}50%{transform:scaleY(0.90)}}
        @keyframes stBar2{0%,100%{transform:scaleY(0.20)}50%{transform:scaleY(0.50)}}
        @keyframes stBar3{0%,100%{transform:scaleY(0.55)}50%{transform:scaleY(1.00)}}
        @keyframes stBar4{0%,100%{transform:scaleY(0.65)}50%{transform:scaleY(1.00)}}
        @keyframes stBar5{0%,100%{transform:scaleY(0.48)}50%{transform:scaleY(0.92)}}
        @keyframes stBar6{0%,100%{transform:scaleY(0.32)}50%{transform:scaleY(0.72)}}
        @keyframes stBar7{0%,100%{transform:scaleY(0.18)}50%{transform:scaleY(0.44)}}
        @keyframes stBar8{0%,100%{transform:scaleY(0.40)}50%{transform:scaleY(0.80)}}
        @keyframes stBar9{0%,100%{transform:scaleY(0.25)}50%{transform:scaleY(0.58)}}
      `}</style>
      <circle cx="16"  cy="18" r="3.5" fill="#7c3aed" opacity="0.75"/>
      <circle cx="147" cy="16" r="5"   fill="#fb923c" opacity="0.90"/>
      <circle cx="139" cy="10" r="2.5" fill="#3b82f6" opacity="0.70"/>
      <rect x="24"  y="10" width="8" height="64" rx="3" fill="#d946ef" style={{transformOrigin:'28px 42px',animation:'stBar0 0.85s 0.00s infinite ease-in-out'}}/>
      <rect x="36"  y="10" width="8" height="64" rx="3" fill="#a855f7" style={{transformOrigin:'40px 42px',animation:'stBar1 1.10s 0.18s infinite ease-in-out'}}/>
      <rect x="48"  y="10" width="8" height="64" rx="3" fill="#eab308" style={{transformOrigin:'52px 42px',animation:'stBar2 0.78s 0.35s infinite ease-in-out'}}/>
      <rect x="60"  y="10" width="8" height="64" rx="3" fill="#facc15" style={{transformOrigin:'64px 42px',animation:'stBar3 1.20s 0.06s infinite ease-in-out'}}/>
      <rect x="72"  y="10" width="8" height="64" rx="3" fill="#3b82f6" style={{transformOrigin:'76px 42px',animation:'stBar4 0.95s 0.50s infinite ease-in-out'}}/>
      <rect x="84"  y="10" width="8" height="64" rx="3" fill="#facc15" style={{transformOrigin:'88px 42px',animation:'stBar5 1.05s 0.22s infinite ease-in-out'}}/>
      <rect x="96"  y="10" width="8" height="64" rx="3" fill="#06b6d4" style={{transformOrigin:'100px 42px',animation:'stBar6 1.15s 0.62s infinite ease-in-out'}}/>
      <rect x="108" y="10" width="8" height="64" rx="3" fill="#22d3ee" style={{transformOrigin:'112px 42px',animation:'stBar7 0.82s 0.12s infinite ease-in-out'}}/>
      <rect x="120" y="10" width="8" height="64" rx="3" fill="#3b82f6" style={{transformOrigin:'124px 42px',animation:'stBar8 1.00s 0.42s infinite ease-in-out'}}/>
      <rect x="132" y="10" width="8" height="64" rx="3" fill="#d946ef" style={{transformOrigin:'136px 42px',animation:'stBar9 0.90s 0.28s infinite ease-in-out'}}/>
    </svg>
  );
};
export default function WhatsAppDemoPage() {
  const [dismissed, setDismissed] = useState(false);

  return (
    <div style={{
      minHeight: '100vh',
      background: DARK,
      backgroundImage: `linear-gradient(rgba(99,102,241,0.04) 1px, transparent 0), linear-gradient(90deg, rgba(99,102,241,0.04) 1px, transparent 0)`,
      backgroundSize: '64px 64px',
      display: 'flex',
      fontFamily: 'Inter, system-ui, sans-serif',
    }}>
      {/* ── Sidebar ──────────────────────────────────────────────── */}
      <div style={{
        width: 220, flexShrink: 0,
        background: SIDEBAR,
        borderRight: `1px solid ${BORDER}`,
        display: 'flex', flexDirection: 'column',
        padding: '20px 0',
      }}>
        {/* Logo */}
        <div style={{ padding: '0 12px 20px', borderBottom: `1px solid ${BORDER}`, marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <AnimatedLogo width={44} />
            <div style={{ lineHeight: 1.3 }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: 'rgba(255,255,255,0.92)', letterSpacing: 0.2, fontFamily: 'Inter, Arial, sans-serif' }}>CallEssential</div>
              <div style={{ fontSize: 9, fontWeight: 500, color: 'rgba(255,255,255,0.42)', letterSpacing: 0.3, fontFamily: 'Inter, Arial, sans-serif' }}>powered by Synergytalk</div>
            </div>
          </div>
        </div>

        {SIDEBAR_ITEMS.map(item => (
          <div key={item.label} style={{
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 20px', margin: '1px 8px', borderRadius: 8,
            background: item.active ? `${WA_GREEN}18` : 'transparent',
            border: item.active ? `1px solid ${WA_GREEN}40` : '1px solid transparent',
            opacity: item.hidden ? 0.12 : 1,
            cursor: item.active ? 'default' : 'not-allowed',
          }}>
            <span style={{ color: item.active ? WA_GREEN : MUTED }}><item.Icon /></span>
            <span style={{
              fontSize: 13, fontWeight: item.active ? 700 : 500,
              color: item.active ? WA_GREEN : MUTED,
            }}>{item.label}</span>
          </div>
        ))}

        <div style={{ flex: 1 }} />
        <div style={{ padding: '12px 20px', borderTop: `1px solid ${BORDER}` }}>
          <a href="/" style={{ fontSize: 12, color: MUTED, textDecoration: 'none' }}>
            ← Back to Demo Hub
          </a>
        </div>
      </div>

      {/* ── Main content ─────────────────────────────────────────── */}
      <div style={{ flex: 1, overflow: 'auto', position: 'relative', padding: '32px 36px' }}>

        {/* Page title */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <span style={{ color: WA_GREEN }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
              </svg>
            </span>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: TEXT }}>WhatsApp Integration</h1>
          </div>
          <div style={{ fontSize: 13, color: MUTED }}>Connect your WhatsApp Business number and configure AI-powered messaging</div>
        </div>

        {/* ── Blurred configuration cards ────────────────────────── */}
        <div style={{ filter: dismissed ? 'blur(6px)' : 'blur(6px)', pointerEvents: 'none', userSelect: 'none' }}>

          {/* Card 1 — WhatsApp Status */}
          <div style={{
            background: 'rgba(30,41,59,0.8)', border: `1px solid ${BORDER}`,
            borderRadius: 14, padding: '24px 28px', marginBottom: 20,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: TEXT }}>WhatsApp Status</div>
                <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>Enable WhatsApp messaging for this tenant</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <FakeToggle on={true} />
                <span style={{ fontSize: 12, color: WA_GREEN, fontWeight: 600 }}>Enabled</span>
              </div>
            </div>
            <div style={{ fontSize: 13, color: MUTED, marginBottom: 12 }}>Webhook URL</div>
            <FakeInput value="https://demo.callessential.cc/api/ai/webhook/whatsapp" wide />
          </div>

          {/* Card 2 — Verify Token */}
          <div style={{
            background: 'rgba(30,41,59,0.8)', border: `1px solid ${BORDER}`,
            borderRadius: 14, padding: '24px 28px', marginBottom: 20,
          }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: TEXT, marginBottom: 6 }}>Webhook Verify Token</div>
            <div style={{ fontSize: 12, color: MUTED, marginBottom: 16 }}>
              Paste this token into the Meta Developer Console when setting up your webhook
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <FakeInput value="61b9bbb4c0d19e295110fe6d9346e14f1252" wide />
              </div>
              <FakeButton label="Save Token" />
            </div>
          </div>

          {/* Card 3 — Agent Access */}
          <div style={{
            background: 'rgba(30,41,59,0.8)', border: `1px solid ${BORDER}`,
            borderRadius: 14, padding: '24px 28px', marginBottom: 20,
          }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: TEXT, marginBottom: 16 }}>Agent Access</div>
            {[
              { role: 'Agent', desc: 'All Agent-role users can see the WhatsApp inbox tab', on: true },
              { role: 'PBX User', desc: 'All PBX User-role users can see the WhatsApp inbox tab', on: false },
            ].map(r => (
              <div key={r.role} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: TEXT }}>{r.role}</div>
                  <div style={{ fontSize: 12, color: MUTED }}>{r.desc}</div>
                </div>
                <FakeToggle on={r.on} />
              </div>
            ))}
          </div>

          {/* Card 4 — Phone Numbers */}
          <div style={{
            background: 'rgba(30,41,59,0.8)', border: `1px solid ${BORDER}`,
            borderRadius: 14, padding: '24px 28px', marginBottom: 20,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: TEXT }}>Business WhatsApp Numbers</div>
                <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>Your verified business numbers from the Meta Business Manager</div>
              </div>
              <FakeButton label="+ Add Number" color="#2563eb" />
            </div>
            {[
              { name: 'Customer Support UAE', number: '+971 4 500 1234', active: true },
              { name: 'Sales UK',             number: '+44 20 7946 0800', active: true },
            ].map(p => (
              <div key={p.name} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '12px 16px', background: 'rgba(255,255,255,0.04)',
                border: `1px solid ${BORDER}`, borderRadius: 8, marginBottom: 8,
              }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: TEXT }}>{p.name}</div>
                  <div style={{ fontSize: 12, color: MUTED }}>{p.number}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 11, color: WA_GREEN, background: `${WA_GREEN}18`, border: `1px solid ${WA_GREEN}40`, borderRadius: 20, padding: '2px 10px', fontWeight: 600 }}>Active</span>
                  <FakeButton label="Edit" color="#6b7280" />
                </div>
              </div>
            ))}
          </div>

        </div>
        {/* ── end blurred content ─────────────────────────────────── */}

        {/* ── Overlay notification ─────────────────────────────────── */}
        <div style={{
          position: 'fixed',
          top: 0, left: 220, right: 0, bottom: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'rgba(15,23,42,0.6)',
          backdropFilter: 'blur(2px)',
          zIndex: 100,
          padding: 24,
        }}>
          <div style={{
            background: 'rgba(30,41,59,0.97)',
            border: `1px solid ${WA_GREEN}60`,
            borderRadius: 20,
            padding: '40px 44px',
            maxWidth: 540,
            textAlign: 'center',
            boxShadow: `0 0 0 1px ${WA_GREEN}20, 0 32px 80px rgba(0,0,0,0.6)`,
          }}>
            {/* WhatsApp logo */}
            <div style={{
              width: 72, height: 72, borderRadius: '50%',
              background: `${WA_GREEN}18`,
              border: `2px solid ${WA_GREEN}60`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', color: WA_GREEN,
            }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                <circle cx="9" cy="12" r="0.8" fill="currentColor" strokeWidth="0"/>
                <circle cx="12" cy="12" r="0.8" fill="currentColor" strokeWidth="0"/>
                <circle cx="15" cy="12" r="0.8" fill="currentColor" strokeWidth="0"/>
              </svg>
            </div>

            <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 12 }}>
              WhatsApp Business Integration
            </div>

            <div style={{
              fontSize: 14, color: MUTED, lineHeight: 1.7, marginBottom: 28,
            }}>
              This configuration will be set up using your own{' '}
              <span style={{ color: WA_GREEN, fontWeight: 600 }}>verified WhatsApp Business number</span>{' '}
              from Meta Business Manager.
              <br /><br />
              Our team will configure the AI chatbot, webhook connection, agent routing,
              and message templates — all tailored to your brand and workflow.
            </div>

            {/* Feature bullets */}
            <div style={{
              background: `${WA_GREEN}0a`,
              border: `1px solid ${WA_GREEN}30`,
              borderRadius: 12, padding: '16px 20px',
              marginBottom: 28, textAlign: 'left',
            }}>
              {[
                'AI chatbot trained on your company knowledge',
                'Human handoff to live agents with full conversation history',
                'Multi-number support (UAE, UK, US and more)',
                'Webhook & Meta Business Manager setup included',
                'Agent access controls per role',
              ].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, fontSize: 13, color: TEXT }}>
                  <span style={{ color: WA_GREEN, fontWeight: 700, marginTop: 1 }}>✓</span>
                  <span>{f}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <a
                href="https://www.callessential.cc/book-demo"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: `linear-gradient(135deg,${WA_GREEN},#1da851)`,
                  borderRadius: 10, color: '#fff', fontSize: 14, fontWeight: 700,
                  textDecoration: 'none',
                }}
              >
                Get Started →
              </a>
              <a
                href="mailto:sales@synergytalk.ae"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 10, color: MUTED, fontSize: 14, fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                Contact Sales
              </a>
              <a
                href="/"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'rgba(255,255,255,0.04)',
                  border: `1px solid ${BORDER}`,
                  borderRadius: 10, color: MUTED, fontSize: 14,
                  textDecoration: 'none',
                }}
              >
                ← Demo Hub
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
